import LocationSettingsIndexRoute from 'garaje/pods/location-settings/index/route';

export default class ManageLocationSettingsIndexRoute extends LocationSettingsIndexRoute {
  controllerName = 'location-settings/index';
  templateName = 'location-settings/index';
}
